skrilla.config(function ($stateProvider, $urlRouterProvider, envServiceProvider, $httpProvider, $locationProvider){
    $urlRouterProvider.otherwise("/admin/home");
    $locationProvider.hashPrefix("");

    function createState(name, url, templateUrl){
        $stateProvider.state(name, {url: url, templateUrl: templateUrl, params:{}})
    }

    createState('home', '/admin/home', 'views/home/home.html');
    createState('login', '/login', 'views/login/login.html');
    createState('users', '/admin/users', 'views/users/users.html');
    createState('admins', '/admin/admins', 'views/admins/admins.html');
    createState('adminDetails', '/admin/adminDetails/:id', 'views/adminDetails/adminDetails.html');
    createState('userDetails', '/admin/userDetails/:id', 'views/userDetails/userDetails.html');
    createState('withdrawals', '/admin/withdrawals?userId=', 'views/withdrawals/withdrawals.html');
    createState('withdrawalDetails', '/admin/withdrawalDetails/:id', 'views/withdrawalDetails/withdrawalDetails.html');
    createState('csgoContests', '/admin/csgoContests', 'views/csgoContests/csgoContests.html');
    createState('csgoContestDetails', '/admin/csgoContestDetails/:id?userId=', 'views/csgoContestDetails/csgoContestDetails.html');
    createState('createCsgoContest', '/admin/createCsgoContest', 'views/createCsgoContest/createCsgoContest.html');
    createState('accounts', '/admin/accounts', 'views/accounts/accounts.html');
    createState('accountDetails', '/admin/accountDetails/:id', 'views/accountDetails/accountDetails.html');
    createState('combinedAccountDetails', '/admin/combinedAccountDetails/:id/:currency', 'views/combinedAccountDetails/combinedAccountDetails.html');
    createState('manualTransactions', '/admin/manualTransactions?id=', 'views/manualTransactions/manualTransactions.html');
    createState('createManualTransaction', '/admin/createManualTransaction', 'views/createManualTransaction/createManualTransaction.html');
    createState('limits', '/admin/limits', 'views/limits/limits.html');
    createState('skrillaJobs', '/admin/skrillaJobs', 'views/skrillaJobs/skrillaJobs.html');
    createState('financials', '/admin/financials', 'views/financials/financials.html');
    createState('csgoData', '/admin/csgoData', 'views/csgoData/csgoData.html');
    createState('excludedUsers', '/admin/excludedUsers?excludedPersonId', 'views/excludedUsers/excludedUsers.html');
    createState('changePassword', '/changePassword', 'views/changePassword/changePassword.html');
    createState('lolData', '/admin/lolData', 'views/lolData/lolData.html');
    createState('lolContests', '/admin/lolContests', 'views/lolContests/lolContests.html');
    createState('createLoLContest', '/admin/createLoLDailyContest', 'views/createLoLDailyContest/createLoLDailyContest.html');
    createState('matchDetails', '/admin/matchDetails/:id', 'views/matchDetails/matchDetails.html');
    createState('csgoMatchDetails', '/admin/csgoMatchDetails/:id', 'views/csgoMatchDetails/csgoMatchDetails.html');
    createState('lolMatchDetails', '/admin/lolMatchDetails/:id', 'views/lolMatchDetails/lolMatchDetails.html');
    createState('lolContestDetails', '/admin/lolContestDetails/:id?userId=', 'views/lolContestDetails/lolContestDetails.html');
    createState('ethereumTransfers', '/admin/ethereumTransfers', 'views/ethereumTransfers/ethereumTransfers.html');
    createState('createMatchPlaceholder', '/admin/createMatchPlaceHolder/:sport', 'views/createMatchPlaceholder/createMatchPlaceholder.html');
    createState('matchPlaceholderDetails', '/admin/matchPlaceholderDetails/:sport/:id', 'views/matchPlaceholderDetails/matchPlaceholderDetails.html');
    createState('sales', '/admin/sales', 'views/sales/sales.html');
    createState('saleDetails', '/admin/saleDetails/:id', 'views/sales/saleDetails.html');
    createState('marketPlace', '/admin/marketPlace', 'views/marketPlace/marketPlace.html');
    createState('skrPurchases', '/admin/skrPurchases', 'views/skrPurchases/skrPurchases.html');
    createState('skrPurchaseDetails', '/admin/skrPurchaseDetails/:id', 'views/skrPurchases/skrPurchaseDetails.html');
    createState('marketPurchaseDetails', '/admin/marketPurchaseDetails/:id', 'views/marketPurchases/marketPurchaseDetails.html');
    createState('promotions', '/admin/promotions', 'views/promotions/promotions.html');
    createState('promotionDetails', '/admin/promotionDetails/:id', 'views/promotionDetails/promotionDetails.html');
    createState('promotionCodeAndClaims', '/admin/promotionCodeAndClaims/:id', 'views/promotionCodeAndClaims/promotionCodeAndClaims.html');
    createState('affiliateDetails', '/admin/affiliateDetails/:id?transactionHash=', 'views/affiliateDetails/affiliateDetails.html');
    createState('promotionClaimDetails', '/admin/promotionClaimDetails/:id', 'views/promotionClaimDetails/promotionClaimDetails.html');
    createState('bets', '/admin/bets?eventIds=', 'views/bets/bets.html');
    createState('betTicker', '/admin/betTicker', 'views/bets/betTicker.html');
    createState('bettingMarkets', '/admin/bettingMarkets?eventId=', 'views/bettingMarkets/bettingMarkets.html');
    createState('betDetails', '/admin/betDetails/:id', 'views/betDetails/betDetails.html');
    createState('bettingMarketDetails', '/admin/bettingMarketDetails/:id', 'views/bettingMarketDetails/bettingMarketDetails.html');
    createState('createBettingMarket', '/admin/createBettingMarket?eventId=&eventType=', 'views/bettingMarketDetails/createMarket.html');
    createState('tournamentDetails', '/admin/tournamentDetails/:id', 'views/tournamentDetails/tournamentDetails.html');
    createState('seasonDetails', '/admin/seasonDetails/:id', 'views/seasonDetails/seasonDetails.html');
    createState('franchiseDetails', '/admin/franchiseDetails/:id', 'views/franchiseDetails/franchiseDetails.html');
    createState('playerDetails', '/admin/playerDetails/:id', 'views/playerDetails/playerDetails.html');
    createState('data', '/admin/data/', 'views/data/data.html');
    createState('sportData', '/admin/data/:sport', 'views/data/data.html');
    createState('createMatch', '/admin/createMatch/:sport?tournamentId=&seasonId=', 'views/createMatch/createMatch.html');
    createState('dota2Data', '/admin/dota2Data', 'views/dota2Data/dota2Data.html');
    createState('dota2Contests', '/admin/dota2Contests', 'views/dota2Contests/dota2Contests.html');
    createState('createDota2Contest', '/admin/createDota2DailyContest', 'views/createDota2DailyContest/createDota2DailyContest.html');
    createState('dota2MatchDetails', '/admin/dota2MatchDetails/:id', 'views/dota2MatchDetails/dota2MatchDetails.html');
    createState('dota2ContestDetails', '/admin/dota2ContestDetails/:id?userId=', 'views/dota2ContestDetails/dota2ContestDetails.html');
    createState('deposits', '/admin/deposits?userId=', 'views/deposits/deposits.html');
    createState('depositDetails', '/admin/depositDetails/:id', 'views/depositDetails/depositDetails.html');
    createState('abaTransactions', '/admin/abaTransactions', 'views/abaTransactions/abaTransactions.html');
    createState('pickemsContests', '/admin/pickems/contests?userId=', 'views/pickems/contests/contests.html');
    createState('pickemsContestDetails', '/admin/pickems/contestDetails/:id', 'views/pickems/contestDetails/contestDetails.html');
    createState('pickemsCreateContest', '/admin/pickems/createContest', 'views/pickems/createContest/createContest.html');
    createState('permissions', '/admin/permissions', 'views/permissions/permissions.html');
    createState('reports', '/admin/reports', 'views/productFeeReports/productFeeReports.html');
    createState('reportDetails', '/admin/reportDetails/:id', 'views/productFeeReportDetails/productFeeReportDetails.html');
    createState('creditCardDetails', '/admin/creditCardDetails/:id', 'views/creditCardDetails/creditCardDetails.html');
    createState('campaignDetails', '/admin/campaignDetails/:id', 'views/campaignDetails/campaignDetails.html');
    createState('incomeAccessReportDetails', '/admin/incomeAccessReportDetails/:id', 'views/incomeAccessReportDetails/incomeAccessReportDetails.html');
    createState('chargebackReportDetails', '/admin/chargeBackReportDetails/:id', 'views/chargebacks/chargebackDetails.html');
    createState('ntrc', '/admin/ntrc', 'views/ntrc/ntrc.html');


    $httpProvider.interceptors.push(function ($window, $location, $q) {
        return {
            'request': function(config) {
                config.headers.authorization = $window.localStorage.token;
                return config;
            },
            'response': function(response) {
                if(response.headers().authorization){
                    $window.localStorage.token = response.headers().authorization;
                }
                return response;
            },
            'responseError': function (rejection) {
                console.log(rejection);
                if(rejection.status === 403){
                    if(rejection.data.errors && rejection.data.errors.length > 0){
                        rejection.data.errors.forEach(function(error){
                            if(error.messageTemplate === "password.reset.required"){
                                if (confirm(error.message)) {
                                    location.href = "/#/changePassword"
                                }
                            }
                            if(error.messageTemplate === "session.expired"){
                                if (confirm(error.message)) {
                                    location.href = "/#/login"
                                }
                            }

                        });
                    } else if (rejection.data.message === "User not authorized.") {
                        alert(rejection.data.message)
                    }
                }
                return $q.reject(rejection);
            }
        };
    });

    const testCloudinary = {
        cloud_name: 'skrilla-test',
        api_key: '698331115539751'
    };
    envServiceProvider.config({
    domains: {
            local: ['localhost', '127.0.0.1'],
            stagingLocal: ['localhost:8002'],
            test1: ['skrilla-t1-admin.firebaseapp.com'],
            test2: ['skrilla-t2-admin.firebaseapp.com'],
            staging: ['skrilla-admin-test.firebaseapp.com'],
            production: ['skrilla-admin-prod.firebaseapp.com']
        },
        vars: {
            local: {
                // //localhost:9090/api/v1/
                apiUrl: '//localhost:8081/application/admin/',
                loginUrl: '//localhost:8081/application/auth/',
                v2Url: 'http://localhost:3000',
                etherscanUrl: 'https://ropsten.etherscan.io/',
                uiUrl: "http://localhost:8000",
                cloudinary: testCloudinary
            },
            stagingLocal: {
                apiUrl: 'https://adminapi.staging.skrilla.com/application/admin/',
                loginUrl: 'https://adminapi.staging.skrilla.com/application/auth/',
                etherscanUrl: 'https://ropsten.etherscan.io/',
                uiUrl: "https://staging.picklebet.com",
                v2Url: 'https://picklebet-admin-staging.vercel.app/',
                cloudinary: testCloudinary
            },
            test1:{
                apiUrl:'//adminapi.t1.skrilla.com/application/admin/',
                loginUrl: '//adminapi.t1.skrilla.com/application/auth/',
                etherscanUrl: 'https://ropsten.etherscan.io/',
                uiUrl: "https://skrilla-t1.firebaseapp.com",
                cloudinary: testCloudinary,
                v2Url: 'https://picklebet-admin-t1.vercel.app/'
            },
            test2:{
                apiUrl:'//adminapi.t2.skrilla.com/application/admin/',
                loginUrl: '//adminapi.t2.skrilla.com/application/auth/',
                etherscanUrl: 'https://ropsten.etherscan.io/',
                cloudinary: testCloudinary,
                v2Url: 'https://picklebet-admin-t2.vercel.app/',
                uiUrl: "https://skrilla-t2.firebaseapp.com"
            },
            staging: {
                apiUrl: '//adminapi.staging.skrilla.com/application/admin/',
                loginUrl: '//adminapi.staging.skrilla.com/application/auth/',
                etherscanUrl: 'https://ropsten.etherscan.io/',
                uiUrl: "https://staging.picklebet.com",
                v2Url: 'https://picklebet-admin-staging.vercel.app/',
                cloudinary: testCloudinary
            },
            production:{
                apiUrl: '//adminapi.skrilla.com/application/admin/',
                loginUrl: '//adminapi.skrilla.com/application/auth/',
                etherscanUrl: 'https://etherscan.io/' ,
                v2Url: 'https://picklebet-admin.vercel.app/',
                cloudinary: {
                    cloud_name: 'skrilla',
                    api_key: '532117636546839'
                },
                uiUrl: "http://picklebet.com"
            }
        }
    });
    envServiceProvider.check();






});
skrilla.run(function(amMoment) {
  amMoment.changeLocale('en-au');
});

//Integrate lodash into angular
skrilla.run(
  function( _ ) { }
);
skrilla.factory(
  "_",
  function( $window ) {
      const _ = $window._;
      return( _ );
  });

skrilla.run(function($rootScope, objectChangeService, $state) {
    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState) {
        if(objectChangeService.containsUnSavedObjects($state.current.name)){
           if(confirm("You have unsaved changes! Are you sure you'd like to leave this page?")){
               objectChangeService.clearObjects();
           }
           else {
               event.preventDefault();
           }
        }
        else{
            objectChangeService.clearObjects();
        }
    });
    window.onbeforeunload = function() {
        if(objectChangeService.containsUnSavedObjects($state.current.name)) {
            return "You have unsaved changes! Are you sure you'd like to leave this page?";
        }
    };
});

skrilla.config(['$provide', function($provide) {
    $provide.decorator('dateFilter', function($delegate, dateService, moment) {
        var srcFilter = $delegate;

        var extendsFilter = function() {

            const dateString = arguments[0];

            let ago = ""
            if (Object.values(arguments).includes('ago')) {
                ago = " (" + moment.utc(dateString).fromNow() + ")";
            }
            arguments[0] = dateService.getDate(dateString);
            let res = srcFilter.apply(this, arguments);
            return res + ago;
        }
        extendsFilter.$stateful = true;
        return extendsFilter;
    })
}])

skrilla.config(function($mdDateLocaleProvider) {
    $mdDateLocaleProvider.formatDate = function(date) {
        return date ? moment(date).format('DD/MM/YYYY') : "";
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
        const m = moment(dateString, 'DD/MM/YYYY', true);
        return m.isValid() ? m.toDate() : new Date(NaN);
    };
});
